import { Router } from '@angular/router';
import { Component, OnInit, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { LoginPartnerService } from 'src/app/services/partner/login-partner/login-partner.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { Task } from 'src/app/models/Task';
import { Modules } from 'src/app/models/Modules';
import { Questions } from 'src/app/models/Questions';
import { Answers } from 'src/app/models/Answers';
import { HelpdeskProcesses } from 'src/app/models/HelpdeskProcesses';
import {MatSort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
@Component({
  selector: 'app-doloci-proces',
  templateUrl: './doloci-proces.component.html',
  styleUrls: ['./doloci-proces.component.css']
})
export class DolociProcesComponent implements OnInit, OnChanges {

  @Input() public dataRow: Task;
  public sessionPartner = this.loginPartnerService.currentSessionValue;
  public userWorker = this.mainService.currentUserValue;
  public userPartner = this.loginPartnerService.currentPartnerValue;
  public dataSourceModules = new MatTableDataSource <Modules>();
  public dataSourceProcesses= new MatTableDataSource <Modules>();
  public dataSourceQuestions= new MatTableDataSource <Questions>();
  public dataSourceAnswers= new MatTableDataSource <Answers>();
  public dataSourceHelpdeskProcesses: Array<HelpdeskProcesses>;
  public displayedColumnsModules: string[];
  public displayedColumnsProcesses: string[];
  public displayedColumnsQuestions: string[];
  public displayedColumnsAnswers: string[];
  public displayedColumnsHelpdeskProcesses: string[];
  public moduleSelectedBool = false;
  public processSelectedBool = false;
  public questionSelectedBool = false;
  public answerSelectedBool = false;
  public notesText;
  public processSelectedTemp: Modules;
  public textQuestions;
  public questionSelectedTemp: Questions;
  public anwserSelectedTemp: Answers;
  public textAnswer;
  public updateQuestion = false;
  public updateAnswer = false;
  public updateQuestionRowSelected: Questions;
  private updateAnswerRowSelected: Answers;
  public selectedModule: Modules;

  //spremenljivke za povečavo tabele
  public moduleZoomBool = false;
  public processZoomBool = false;
  public questionZoomBool = false;
  public answerZoomBool = false;
  public communicationIdChat;

  @ViewChild('sortM', { read: MatSort, static: true}) public sortM: MatSort;

  @ViewChild('sortP', { read: MatSort, static: true}) public sortP: MatSort;

  @ViewChild('sortQ', { read: MatSort, static: true}) public sortQ: MatSort;

  @ViewChild('sortA', { read: MatSort, static: true}) public sortA: MatSort;
  constructor(private helpdeskService: HelpdeskService, private loginPartnerService: LoginPartnerService,
              private mainService: MainService, private _snackBar: MatSnackBar, private router: Router) { }


  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.ngOnInit();
    }
  }

  ngOnInit() {

    this.helpdeskService.currentHelpdeskParameters.subscribe(data => {
      this.communicationIdChat = data.communicationIdChat;
      
    });

    this.displayedColumnsModules = ['code', 'nameSmall', 'descriptionSmall'];
    this.displayedColumnsProcesses = ['code', 'nameSmall', 'descriptionSmall'];
    this.displayedColumnsQuestions = ['code', 'nameSmall', 'more'];
    this.displayedColumnsAnswers = ['code', 'descriptionLarge', 'points', 'more'];
    this.displayedColumnsHelpdeskProcesses = ['moduleNameSmall', 'processNameSmall', 'questionNameSmall', 'answerNameSmall'];
    if (this.dataRow) {
      this.getModules();
      this.sessionPartner = this.loginPartnerService.currentSessionValue;
      this.userWorker = this.mainService.currentUserValue;
      this.userPartner = this.loginPartnerService.currentPartnerValue;
      this.getHelpdeskProcess();
    }

     console.log("datarow id: " + this.dataRow.id);
     console.log("parnerid: " + this.dataRow.partnerId);
  }

  getModules() {
    this.helpdeskService.getModules(this.mainService.currentUserValue, this.dataRow.partnerId).subscribe(data => {
      this.dataSourceModules = new MatTableDataSource(data.data.modules);
      this.dataSourceModules.sort = this.sortM;
    }, error => {
      console.log(error);
    });
  }

  onModuleSelected(row: Modules) {
    this.dataSourceQuestions = null;
    this.dataSourceAnswers = null;
    this.selectedModule = row;
    this.helpdeskService.getProcesses(this.mainService.currentUserValue, row.id, null).subscribe( data => {
      this.dataSourceProcesses = new MatTableDataSource(data.data.modules);
      this.dataSourceProcesses.sort = this.sortP;
      console.log(data);
    }, error => {
      console.log(error);
    });

  }

  onProcessSelected(row: Modules) {
    this.processSelectedTemp = row;
    this.dataSourceAnswers = null;
    this.helpdeskService.getQuestions(this.mainService.currentUserValue, row.id, null,null).subscribe( data => {
      this.dataSourceQuestions = new MatTableDataSource(data.data.questions);
      this.dataSourceQuestions.sort = this.sortQ;
      
    }, error => {
      console.log(error);
    });
  }

  onQuestionSelected(row: Questions) {
    this.questionSelectedTemp = row;
    this.helpdeskService.getAnswers(this.mainService.currentUserValue, row.id, null,null).subscribe( data => {
      this.dataSourceAnswers = new MatTableDataSource(data.data.answers);
      this.dataSourceAnswers.sort = this.sortA;
    }, error => {
      console.log(error);
    });
  }

  onAnswerSelected(row: Answers) {
    this.anwserSelectedTemp = row;
    this.helpdeskService.updateDiary(this.mainService.currentUserValue, this.dataRow.id, row.id,
       this.processSelectedTemp.id, null, this.selectedModule.id, this.questionSelectedTemp.id ).subscribe( data => {
      this.getHelpdeskProcess();
    }, error => {
      console.log(error);
    });
  }

  //trenuten proces se tu dobi in zapiše v dataSourceHelpdeskProcesses
  getHelpdeskProcess() {
    this.helpdeskService.getHelpdeskProcess(this.mainService.currentUserValue, this.dataRow.id).subscribe( data => {
      let arrayProcesses: Array<HelpdeskProcesses> = [];
      arrayProcesses[0] = data.data;
      this.dataSourceHelpdeskProcesses = arrayProcesses;
      this.notesText = arrayProcesses[0].note;
    }, error => {
      console.log(error);
    });
  }

  onNotesSubmitted() {
    this.helpdeskService.updateDiary(this.mainService.currentUserValue, this.dataRow.id,
       null, null, this.notesText, this.selectedModule.id, this.questionSelectedTemp.id).subscribe( data => {
      this.getHelpdeskProcess();
      this._snackBar.open('Uspešno dodano!', '', {
        duration: 2000,
      });
    }, error => {
      console.log(error);
      this._snackBar.open('Napaka!', '', {
        duration: 2000,
      });
    });
  }

  onAddQuestion() {
    this.helpdeskService.setQuestion(this.mainService.currentUserValue, this.textQuestions,
       this.processSelectedTemp.id).subscribe( data => {
         this.getQuestions();
         this._snackBar.open('Uspešno dodano!', '', {
          duration: 2000,
        });
       }, error => {
         console.log(error);
         this._snackBar.open('Napaka!', '', {
          duration: 2000,
        });
       });
  }

  getQuestions() {
    this.helpdeskService.getQuestions(this.mainService.currentUserValue, this.processSelectedTemp.id, null,null).subscribe( data => {
      this.dataSourceQuestions = new MatTableDataSource(data.data.questions);
      this.dataSourceQuestions.sort = this.sortQ;
    }, error => {
      console.log(error);
    });
  }

  onAddAnswer() {
    this.helpdeskService.setAnswer(this.mainService.currentUserValue, this.textAnswer,
      this.questionSelectedTemp.id).subscribe( data => {
        this.getAnswers();
        this._snackBar.open('Uspešno dodano!', '', {
          duration: 2000,
        });
      }, error => {
        console.log(error);
        this._snackBar.open('Napaka!', '', {
          duration: 2000,
        });
      });
  }

  getAnswers() {
    this.helpdeskService.getAnswers(this.mainService.currentUserValue, this.questionSelectedTemp.id
      , null,null).subscribe( data => {
      this.dataSourceAnswers = new MatTableDataSource(data.data.answers);
      this.dataSourceAnswers.sort = this.sortA;
    }, error => {
      console.log(error);
    });
    this.textAnswer = null;
  }

  onMoreClick() {

  }

  onUpdateQuestion(row: Questions) {
    this.textQuestions = row.nameSmall;
    this.updateQuestion = true;
    this.updateQuestionRowSelected = row;
  }

  updateQuestionCall() {
    this.helpdeskService.updateQuestion(this.mainService.currentUserValue, this.updateQuestionRowSelected.id, this.textQuestions,
      this.processSelectedTemp.id).subscribe( data => {
        this.getQuestions();
        this.disableUpdateQuestion();
        this._snackBar.open('Uspešno posodobljeno!', '', {
          duration: 2000,
        });
      }, error => {
        console.log(error);
        this._snackBar.open('Napaka!', '', {
          duration: 2000,
        });
      });
  }

  disableUpdateQuestion() {
    this.updateQuestion = false;
    this.textQuestions = null;
  }


  onDeleteQuestion(row: Questions) {
    this.helpdeskService.deleteQuestion(this.mainService.currentUserValue, row.id, row.nameSmall,
      this.processSelectedTemp.id).subscribe( data => {
        this.getQuestions();
        this._snackBar.open('Uspešno izbrisano!', '', {
          duration: 2000,
        });
      }, error => {
        console.log(error);
        this._snackBar.open('Napaka!', '', {
          duration: 2000,
        });
      });
  }

  onUpdateAnswer(row: Answers) {
    this.textAnswer = row.descriptionLarge;
    this.updateAnswer = true;
    this.updateAnswerRowSelected = row;
  }

  updateAnswerCall() {
    this.helpdeskService.updateAnswer(this.mainService.currentUserValue, this.updateAnswerRowSelected.id, this.textAnswer,
      this.questionSelectedTemp.id).subscribe( data => {
        this.getAnswers();
        this.disableUpdateAnswer();
        this._snackBar.open('Uspešno posodobljeno!', '', {
          duration: 2000,
        });
      }, error => {
        console.log(error);
        this._snackBar.open('Napaka!', '', {
          duration: 2000,
        });
      });
  }
  disableUpdateAnswer() {
    this.updateAnswer = false;
    this.textAnswer = null;
  }

  onDeleteAnswer(row: Answers) {
    this.helpdeskService.deleteAnswer(this.mainService.currentUserValue, row.id, this.textAnswer,
      this.questionSelectedTemp.id).subscribe( data => {
        this.getAnswers();
        this._snackBar.open('Uspešno izbrisano!', '', {
          duration: 2000,
        });
      }, error => {
        console.log(error);
        this._snackBar.open('Napaka!', '', {
          duration: 2000,
        });
      });
  }
  onModulesZoom() {
    if (this.moduleZoomBool) {
      this.moduleZoomBool = false;
    } else {
      this.moduleZoomBool = true;
    }
  }

  onProcessesZoom() {
    if (this.processZoomBool) {
      this.processZoomBool = false;
    } else {
      this.processZoomBool = true;
    }
  }

  onQuestionsZoom() {
    if (this.questionZoomBool) {
      this.questionZoomBool = false;
    } else {
      this.questionZoomBool = true;
    }
  }

  onAnswersZoom() {
    if (this.answerZoomBool) {
      this.answerZoomBool = false;
    } else {
      this.answerZoomBool = true;
    }
  }

  applyFilter(event: Event, datasource) {
    const filterValue = (event.target as HTMLInputElement).value;
    datasource.filter = filterValue.trim().toLowerCase();
  }

  //zakljuci gumb, ki potrdi task in gre na pregled-helpdeska
  finishTask() {
    if(this.dataSourceHelpdeskProcesses) {
      this.setTaskStatus(3);

      this.router.navigate(['/pregled-helpdeska']);
    }

  }

  setTaskStatus(selectedStatus) {
   this.helpdeskService.setTaskStatus(
      this.mainService.currentUserValue, this.dataRow.text, this.dataRow.id, selectedStatus, this.dataRow.contactId, this.communicationIdChat).subscribe( data => {
        //this.updateTask(this.dataRow.id);
      }, error => {
        console.log(error);
        /*this._snackbar.open(error.error.errorUser , '', {
          duration: 2000,
        });*/
      });
  }

  onStopWorking() {
    this.helpdeskService.deleteCurrentWorker(this.mainService.currentUserValue, this.dataRow.id).subscribe( data => {

    }, error => {
      console.log(error);
    });
  }

}
